import { Action } from '@ngrx/store';
import { PayloadAction } from '@ipreo/muni-shared';
import { USTreasuries, USTreasury } from '../../models/us-treasury';

const USTREASURIES_LOAD_REQUESTED = '[marketDrawer] Fetch USTreasuries';
const USTREASURIES_LOAD_SUCCESS = '[marketDrawer] Fetch USTreasuries Success';
const USTREASURIES_LOAD_ERROR = '[marketDrawer] Fetch USTreasuries Error';
const USTREASURY_SELECTED = '[marketDrawer] USTreasuries Selected';
const USTREASURY_EVENT_RECEIVED = '[marketDrawer] USTreasuries Event Received';

/* tslint:disable:no-null-keyword */
class USTreasuriesLoadAction implements Action {
    public readonly type = USTREASURIES_LOAD_REQUESTED;
    public readonly payload: null = null;
}

class USTreasuriesLoadSuccessAction implements PayloadAction<USTreasuries> {
    public readonly type = USTREASURIES_LOAD_SUCCESS;

    constructor(public payload: USTreasuries) {}
}

class USTreasuriesLoadErrorAction implements PayloadAction<string> {
    public readonly type = USTREASURIES_LOAD_ERROR;

    constructor(public payload: string) {}
}

class SelectedUSTreasuryChangedAction implements PayloadAction<USTreasury> {
    public readonly type = USTREASURY_SELECTED;

    constructor(public payload: USTreasury) {}
}

class USTreasuryEventReceivedAction implements PayloadAction<USTreasury> {
    public readonly type = USTREASURY_EVENT_RECEIVED;

    constructor(public payload: USTreasury) {}
}

type Actions =
    | USTreasuriesLoadAction
    | USTreasuriesLoadSuccessAction
    | USTreasuriesLoadErrorAction
    | SelectedUSTreasuryChangedAction
    | USTreasuryEventReceivedAction;

export {
    USTREASURIES_LOAD_REQUESTED,
    USTREASURIES_LOAD_SUCCESS,
    USTREASURIES_LOAD_ERROR,
    USTREASURY_SELECTED,
    USTREASURY_EVENT_RECEIVED,
    USTreasuriesLoadAction,
    USTreasuriesLoadSuccessAction,
    USTreasuriesLoadErrorAction,
    SelectedUSTreasuryChangedAction,
    USTreasuryEventReceivedAction,
    Actions
};
